export const MAX_DESCRIPTION_LEN = 300;
export const MAX_PRICE = 1000000;
export const MAX_DURATION = 1000;
